import { useCallback, useState } from 'react';
import { useLocale, useTranslation } from '../../i18n/react';
import { appHref } from '../../routing/browser';
import { PromptEditor } from './PromptLibraryPage';
import { getPromptTemplate, promptShortcutThumbnail, promptShortcutSlots } from './templateCatalog';
import './prompt-quick-dock.css';

export function PromptQuickDock() {
  const tr = useTranslation();
  const locale = useLocale();
  const [activeId, setActiveId] = useState<string | null>(null);
  const closeEditor = useCallback(() => setActiveId(null), []);
  const active = activeId ? getPromptTemplate(activeId) : undefined;

  return <>
    <section className="prompt-quick-dock" aria-label={locale === 'en' ? 'Open a poster prompt' : 'Mở nhanh prompt poster'}>
      <div className="prompt-quick-dock-items">
        {promptShortcutSlots.map((template, index) => template ? <button
          key={template.id}
          type="button"
          className="prompt-glass-button"
          data-prompt-id={template.id}
          aria-label={tr(`Mở mẫu ${template.cardTitle}`)}
          aria-haspopup="dialog"
          title={template.cardTitle}
          onClick={() => setActiveId(template.id)}
        >
          <img className="prompt-glass-thumbnail" src={appHref(promptShortcutThumbnail(template.id))} alt="" width={160} height={160} loading="lazy" decoding="async" draggable={false}/>
        </button> : <button
          key={`empty-${index}`}
          type="button"
          className="prompt-glass-button is-placeholder"
          aria-label={locale === 'en' ? 'More prompts coming soon' : 'Sẽ bổ sung prompt mới'}
          title={locale === 'en' ? 'More prompts coming soon' : 'Sẽ bổ sung prompt mới'}
          disabled
        />)}
      </div>
    </section>
    {active && <PromptEditor key={active.id} template={active} onClose={closeEditor}/>}
  </>;
}
